export enum UPLOADER_SERVICE_UNIQUE_IDS_ENUM {
    WORKSPACE_LOGO = 'workspaceLogo',
    ORGANIZATION_LOGO = 'organizationLogo',
    PROJECT_LOGO = 'projectLogo',
    ASSET = 'asset',
    BRANDING = 'branding',
    TAKE_VIDEO = 'takeVideo',
    TAKE_IMAGE = 'takeImage',
    TAKE_LOGO = 'takeLogo',
    ASSET_LIBRARY = 'assetLibrary',
}

export interface IUploader {
    type: UPLOADER_SERVICE_UNIQUE_IDS_ENUM;
}
